package fr.manyverse.app.presentation.components.modules.combat

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.Image
import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.model.CombatParticipant
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.combat_bubble_description
import manyverse.shared.generated.resources.icon_sword_cross
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

/**
 * Bulle flottante du combat (MJ minimisé + joueur).
 * Arrière-plan : icône d'épées croisées ; au premier plan : l'avatar du participant actif.
 */
@OptIn(ExperimentalFoundationApi::class)
@Composable
fun CombatBubble(
    activeParticipant: CombatParticipant?,
    characters: List<Character>,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    onDoubleClick: (() -> Unit)? = null
) {
    val description = stringResource(Res.string.combat_bubble_description)
    Surface(
        shape = RoundedCornerShape(12.dp),
        color = MaterialTheme.colorScheme.primaryContainer,
        shadowElevation = 6.dp,
        modifier = modifier
            .size(56.dp)
            .clip(RoundedCornerShape(12.dp))
            .combinedClickable(onClick = onClick, onDoubleClick = onDoubleClick)
            .semantics { contentDescription = description }
    ) {
        Box(contentAlignment = Alignment.Center) {
            // Arrière-plan : épées croisées
            Image(
                painter = painterResource(Res.drawable.icon_sword_cross),
                contentDescription = null,
                contentScale = ContentScale.Crop,
                colorFilter = ColorFilter.tint(
                    MaterialTheme.colorScheme.onPrimaryContainer.copy(alpha = 0.18f)
                ),
                modifier = Modifier.size(48.dp)
            )
            // Premier plan : participant actif
            if (activeParticipant != null) {
                CombatParticipantAvatar(
                    participant = activeParticipant,
                    characters = characters,
                    size = 36.dp
                )
            }
        }
    }
}
